'use client';

// Recovered from the IMAI v5 animation source; demo documents stay illustrative.
import * as React from 'react';
import { ShowcaseCopyContext, translateShowcaseNode } from '../translation';
import {
  id,
  rd,
  ad,
  sd,
  od,
  fd,
  ConceptBadge,
  BuyerSlideHeading,
  BuyerSlideTable,
  hd,
  md,
  pd,
} from './publish-approval';
import { MarketReveal, Wl, Zl, Hl, zl, Vl } from './collection-animation';
import { MarketImage } from './market-primitives';
import { referenceImages, LisiereLogo } from './reference-brands';
import { ue } from './reference-products';
export function Scene_gd({ lt: e }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <div
      className={'mk-page grid size-full grid-cols-[1fr_1.15fr]'}
      style={{
        background: id,
        color: rd,
      }}
    >
      <MarketReveal on={e >= 0} className={'relative size-full'}>
        <MarketImage
          asset={referenceImages.lisiere.campaign}
          focus={'50% 45%'}
          className={'size-full'}
        />
      </MarketReveal>
      <div className={'flex flex-col p-[2.4em]'}>
        <MarketReveal on={e >= 150} className={'flex flex-col gap-[0.6em]'}>
          <LisiereLogo className={'h-[2.2em] w-auto self-start'} />
          <span
            className={'mk-caps text-[0.8em]'}
            style={{
              color: ad,
            }}
          >
            {translateShowcaseNode(showcaseCopy, 'Fall/Winter 2027 \xB7 for ')}
            {translateShowcaseNode(showcaseCopy, Wl.audience)}
          </span>
        </MarketReveal>
        <MarketReveal
          on={e >= 300}
          as={'h3'}
          className={'mk-serif mt-[0.5em] text-[2.9em] leading-[1]'}
        >
          {translateShowcaseNode(showcaseCopy, ue.name)}
          {translateShowcaseNode(showcaseCopy, '.')}
        </MarketReveal>
        <p
          className={'mt-[0.9em] text-[1em] leading-[1.45]'}
          style={{
            color: sd,
          }}
        >
          {translateShowcaseNode(showcaseCopy, Zl(ue.line, e, 520, 45))}
        </p>
        <MarketReveal
          on={e >= 900}
          className={'mt-auto flex items-center gap-[0.5em]'}
        >
          {translateShowcaseNode(
            showcaseCopy,
            Hl.map((e) => (
              <span
                key={e}
                className={'size-[1.4em] rounded-full'}
                style={{
                  background: e,
                  boxShadow: `inset 0 0 0 1px ${od}`,
                }}
              />
            ))
          )}
        </MarketReveal>
      </div>
    </div>
  );
}
export function BuyerProductSlide({ lt: e }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  let t = fd(e);
  return (
    <div className={'relative size-full'}>
      {translateShowcaseNode(
        showcaseCopy,
        zl.map((e, n) => (
          <div
            key={e.id}
            className={'mk-slide absolute inset-0'}
            data-active={n === t}
            aria-hidden={n !== t}
          >
            <div
              className={'mk-page grid size-full grid-cols-[1fr_1fr]'}
              style={{
                background: id,
                color: rd,
              }}
            >
              <span className={'relative block size-full'}>
                <MarketImage
                  asset={e.asset}
                  alt={translateShowcaseNode(showcaseCopy, e.title)}
                  className={'size-full'}
                />
                <ConceptBadge />
              </span>
              <div className={'flex flex-col p-[2.2em]'}>
                <span
                  className={'mk-caps num text-[0.75em]'}
                  style={{
                    color: ad,
                  }}
                >
                  {translateShowcaseNode(
                    showcaseCopy,
                    String(n + 2).padStart(2, '0')
                  )}
                  {translateShowcaseNode(showcaseCopy, ' / 11 \xB7 ')}
                  {translateShowcaseNode(showcaseCopy, e.category)}
                </span>
                <h3 className={'mk-serif mt-[0.5em] text-[2.6em] leading-[1]'}>
                  {translateShowcaseNode(showcaseCopy, e.title)}
                </h3>
                <span
                  className={'mt-[0.4em] text-[1em]'}
                  style={{
                    color: sd,
                  }}
                >
                  {translateShowcaseNode(showcaseCopy, e.name)}
                </span>
                <dl
                  className={
                    'num mt-auto grid grid-cols-3 gap-[0.8em] text-[0.9em]'
                  }
                >
                  {translateShowcaseNode(
                    showcaseCopy,
                    [
                      ['Colourway', e.colorway],
                      ['Wholesale', Vl(e.wholesale)],
                      ['Retail', Vl(e.retail)],
                    ].map(([e, t]) => (
                      <div
                        key={e}
                        style={{
                          borderTop: `1px solid ${od}`,
                        }}
                        className={'pt-[0.4em]'}
                      >
                        <dt
                          className={'mk-caps text-[0.7em]'}
                          style={{
                            color: ad,
                          }}
                        >
                          {translateShowcaseNode(showcaseCopy, e)}
                        </dt>
                        <dd>{translateShowcaseNode(showcaseCopy, t)}</dd>
                      </div>
                    ))
                  )}
                </dl>
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  );
}
export const vd = [...zl].sort((e, t) => t.retail - e.retail);
export function BuyerPriceSlide({ lt: e }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <BuyerSlideHeading
      title={translateShowcaseNode(showcaseCopy, 'Price architecture')}
      slide={8}
    >
      <BuyerSlideTable
        lt={e}
        cols={'1.6fr 1fr 0.8fr 0.8fr 2fr'}
        head={['Style', 'Category', 'Wholesale', 'Retail', '']}
        rows={[
          ...vd.map((t, n) => ({
            key: t.id,
            cells: [
              t.title,
              t.category,
              Vl(t.wholesale),
              Vl(t.retail),
              <span key={'bar'} className={'relative block h-[0.6em]'}>
                <span
                  data-on={e >= 260 + n * 110}
                  className={'mk-grow absolute inset-y-0 left-0 rounded-full'}
                  style={{
                    width: `${(t.retail / hd) * 100}%`,
                    background: od,
                  }}
                />
                <span
                  data-on={e >= 360 + n * 110}
                  className={'mk-grow absolute inset-y-0 left-0 rounded-full'}
                  style={{
                    width: `${(t.wholesale / hd) * 100}%`,
                    background: rd,
                  }}
                />
              </span>,
            ],
          })),
          {
            key: 'total',
            total: !0,
            cells: ['Total', '', Vl(md), Vl(pd), ''],
          },
        ]}
      />
      <MarketReveal
        on={e >= 1e3}
        className={'mt-[0.8em] text-[0.75em]'}
        style={{
          color: ad,
        }}
      >
        {translateShowcaseNode(
          showcaseCopy,
          'USD \xB7 proposed retail \xB7 wholesale about 50% of retail'
        )}
      </MarketReveal>
    </BuyerSlideHeading>
  );
}
export function BuyerTermsSlide({ lt: e }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <BuyerSlideHeading
      title={translateShowcaseNode(showcaseCopy, 'Proposed terms')}
      slide={9}
    >
      <dl className={'flex flex-col'}>
        {translateShowcaseNode(
          showcaseCopy,
          Wl.terms.map((t, n) => {
            let r = t.value === 'To be confirmed';
            return (
              <MarketReveal
                key={t.label}
                on={e >= 140 + n * 140}
                className={'grid grid-cols-[1fr_2fr] gap-[1em] py-[0.55em]'}
                style={{
                  borderBottom: `1px solid ${od}`,
                }}
              >
                <dt
                  className={'mk-caps text-[0.75em] leading-[1.9]'}
                  style={{
                    color: ad,
                  }}
                >
                  {translateShowcaseNode(showcaseCopy, t.label)}
                </dt>
                <dd
                  className={'text-[1em]'}
                  style={{
                    color: r ? ad : rd,
                  }}
                >
                  {translateShowcaseNode(showcaseCopy, t.value)}
                </dd>
              </MarketReveal>
            );
          })
        )}
      </dl>
    </BuyerSlideHeading>
  );
}
export function BuyerNextSteps({ lt: e }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <BuyerSlideHeading
      title={translateShowcaseNode(showcaseCopy, 'Next step')}
      slide={10}
    >
      <div className={'grid grid-cols-2 gap-[1.2em]'}>
        {translateShowcaseNode(
          showcaseCopy,
          Wl.next.map((t, n) => (
            <MarketReveal
              key={t}
              pop={!0}
              on={e >= 160 + n * 200}
              className={'flex flex-col gap-[0.6em] rounded-[0.4em] p-[1.2em]'}
              style={{
                boxShadow: `inset 0 0 0 1px ${od}`,
              }}
            >
              <span
                className={'mk-caps num text-[0.75em]'}
                style={{
                  color: ad,
                }}
              >
                {translateShowcaseNode(
                  showcaseCopy,
                  String(n + 1).padStart(2, '0')
                )}
              </span>
              <span className={'mk-serif text-[1.9em] leading-[1.05]'}>
                {translateShowcaseNode(showcaseCopy, t)}
              </span>
            </MarketReveal>
          ))
        )}
      </div>
      <MarketReveal
        on={e >= 700}
        className={'mt-[1.2em] text-[0.9em]'}
        style={{
          color: sd,
        }}
      >
        {translateShowcaseNode(showcaseCopy, 'Delivery ')}
        {translateShowcaseNode(showcaseCopy, Wl.delivery)}
        {translateShowcaseNode(showcaseCopy, '.')}
      </MarketReveal>
    </BuyerSlideHeading>
  );
}
